export enum VatActionPoint {
  SettleVat = 1,
}
